import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const removeRule: prophetTypes.DeleteRule = (params) => {
  return axios.delete('/prophet/rules', { params });
};

type UseRemoveRuleOptions = {
  pageId: string;
  config?: MutationConfig<typeof removeRule>;
};

export function useRemoveRule({ config = {}, pageId }: UseRemoveRuleOptions) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['prophet-rules', pageId]);
    },
    ...config,
    mutationFn: removeRule,
  });
}
